import { GetServerSideProps, NextPage } from 'next'
import { SSRConfig } from 'next-i18next'

export * from './integration'
export * from './convergence'
export * from './preferredPaymentDay'
export * from './biometric'
export * from './errors'
export * from './country'
export * from './checkout'
export * from './consumer'
export * from './donation'
export * from './payment'
export * from './auth'
export * from './verify'
export * from './password'
export * from './shippingAddress'
export * from './shippingOption'
export * from './registration'
export * from './identity'
export * from './onboarding'
export * from './experiments'
export * from './tags'
export * from './http'
export * from './cardScan'
export * from './oAuth'
export * from './features'
export * from './overduePayments'
export * from './topaz'
export * from './recoverableTerminalErrors'
export * from './postcheckout'
export * from './monitoring'
export * from './modalKey'
export * from './uiControl'
export * from './theming'

export type CheckoutProps<T> = T & SSRConfig

export type CheckoutPage<T = object> = NextPage<CheckoutProps<T>> & {
  getLayout?: (page: unknown) => JSX.Element
}

export type GetCheckoutSSP<T = object> = GetServerSideProps<CheckoutProps<T>>

export interface ParsedContext {
  hasToken: boolean
  locale: string
  query: string
}

export enum PageLayout {
  Blank = 'Blank',
  Main = 'Main',
  Summary = 'Summary',
}

export const SHOW_NEW_CHECKOUT_COOKIE_NAME = 'x-apt-new-checkout'
export const APT_USER_ID = 'apt-user-id'
export const APT_USER_COUNTRY = 'apt-user-country'
export const APT_USERNAME = 'apt-username'
export const ORDER_TRANSACTION_TOKEN_COOKIE_NAME = 'apt-order-transaction-token'
